import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell, Field, TextInput, btnPrimary } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (ev) => {
    ev.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
      toast.success("Tautan reset terkirim (jika email terdaftar).");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Lupa Kata Sandi?"
      subtitle="Masukkan email akun IEC Anda. Kami akan mengirimkan tautan reset kata sandi."
    >
      {sent ? (
        <div
          data-testid="forgot-success-alert"
          className="rounded-xl border border-green-200 bg-green-50 p-5 text-center"
        >
          <CheckCircle2 className="h-10 w-10 text-green-600 mx-auto mb-3" />
          <p className="font-semibold text-slate-900">Instruksi Pemulihan Terkirim!</p>
          <p className="text-sm text-slate-600 mt-1">
            Jika email terdaftar pada sistem kami, tautan reset telah dikirim. Tautan berlaku 60 menit.
          </p>
          <Link
            to="/login"
            className="inline-block mt-4 text-sm text-[#1e5ea5] hover:text-[#0f2847] font-medium"
            data-testid="forgot-back-to-login-link"
          >
            Kembali ke Halaman Masuk
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email Terdaftar">
            <TextInput
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nama@iec.ac.id"
              data-testid="forgot-email-input"
            />
          </Field>
          {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
          <button type="submit" disabled={loading} className={btnPrimary} data-testid="forgot-submit-button">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Kirim Tautan Reset
          </button>
          <div className="text-center">
            <Link to="/login" className="text-sm text-[#1e5ea5] hover:text-[#0f2847] font-medium" data-testid="forgot-back-to-login-link">
              Kembali ke Halaman Masuk
            </Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
